import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { AuthAction } from '@cbridge-packages/auth';
import { UserSettingsAction } from '../userSettings.action';

/**
 * The /token response carries only excludedScope, so the settings are requested
 * from GET /profile/settings immediately after login; UserSettingsGate holds
 * rendering until they arrive.
 */
export const requestUserSettingsOnLoginEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(AuthAction.loginDone),
  map(() => UserSettingsAction.load.started()),
);
